<template>
  <div class="container-fluid">
    <groups-list></groups-list>
  </div>
</template>

<script>
import GroupsList from './components/GroupsList.vue';

export default {
  name: 'App',
  components: {
    GroupsList
}
}

</script>

<style>
  /*body {
    background-image: url('~@/assets/bg.jpg');
  }*/
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #FFF;
  padding-top: 30px;
  margin: 0px auto;
  max-width: 1050px;
}
</style>
